<template>
    <div class="footer-occupy">
        <div :class="['footer']">
            <div class="footer-tags ">
                <div class="flex-center-lr min-width footer-tags-item">
                    <div class="flex-center-lr flex_1" v-for="item,i in tagsList" :key="i">
                      <img :src="item.icon" class="footer-tags-icon"/>
                      <p>{{item.title}}</p>
                    </div>
                </div>
                
            </div>
            <div class="footer-black flex-tb">
                <div class="min-width flex-lr-between">
                    <div>
                        <p class="footer-call">联系我们</p>
                        <img src="../assets/img/footer_tel.png" class="footer-tel"/>
                        <p>地址：成都市锦江区菱窠东路122号滨江天际9栋19楼</p>
                        <p>邮箱：3640241847@qq.com</p>
                    </div>
                    <div class="flex-between-center footer-qr">
                        <div>
                            <img src="../assets/img/qr.jpg"/>
                            <p class="text-center">扫码关注</p>
                        </div>
                        <div>
                            <img src="../assets/img/mp.jpg"/>
                            <p class="text-center">扫码下单</p>
                        </div>
                    </div>
                </div>
                 <div class="min-width footer-information">
                    四川恒鑫义环保新材料有限公司版权所有     |   
                    备案号：
                    <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">蜀ICP备2023041779号-2</a>
                    <a
                      href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51015602000983" 
                      class="mlr-10" target="_blank" rel="noopener noreferrer"
                    >川公网安备：51015602000983号</a>
                    增值电信业务经营许可证：川B2-20241750
                </div>
            </div>
        </div>
       
    </div>
</template>

<script>
export default {
    name: 'Footer', 
    data () {
        return {
            tagsList:[
            {icon:require('@/assets/img/footer_icon01.png'),title:'源头直供  货真价实'},
            {icon:require('@/assets/img/footer_icon02.png'),title:'品类齐全  一站购齐'},
            {icon:require('@/assets/img/footer_icon03.png'),title:'统一仓储  自建物流'},
            {icon:require('@/assets/img/footer_icon04.png'),title:'极速送达 灵活开票'},
            ],
            fixedBool:true,
        }
    },
    created() { 
        // this.loadlinks()
    },
    mounted() {
        if(this.$route.name == 'index'){
            this.fixedBool = false
        }
    },
    methods: {
 
    }
}
</script>

<style scoped lang="scss">
.footer-occupy{
    position: relative;
    z-index: 100;
    height: 450px;
    width: 100%;
}
.footer{
    min-width: 1200px;
    &-fixed{
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
    }
    &-tags{
        height: 140px;
        background-color: #fff;
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        &-icon{
            width: 62px;
            height: 62px;
            margin-right: 12px;

        }
    }
    &-black{
        background-color: #333333;
        font-size: 12px;
        line-height: 26px;
        height: 310px;
        & p{
            color: #EDEDED;
        }
    }
    &-qr{
        font-size: 14px;
        line-height: 40px;
        width: 350px;
        padding-top: 46px;
        & img{
            width: 140px;
            height: 140px;
        }
    }
    &-call{
        padding-top: 46px;
        font-size: 18px;
        line-height: 24px;
    }
    &-tel{
        width: 202px;
        height: 40px;
        margin: 24px 0 30px;
    }
    &-information{
        border-top: 1px solid #414141;
        margin-top: 20px;
        font-size: 12px;
        color: #666666;
        line-height: 32px;
        text-align: center;
        a {
          color: #666666;
        }
    }
}
</style>
